import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cx } from "./cx";

export type VarianteBotao = "primario" | "secundario" | "fantasma" | "perigo" | "invertido";

const VARIANTE: Record<VarianteBotao, string> = {
  primario: "bg-acao text-acao-texto hover:bg-acao-hover",
  secundario: "fio-forte bg-superficie text-texto-1 hover:bg-superficie-2",
  fantasma: "text-texto-1 hover:bg-superficie-2",
  perigo: "fio-forte bg-superficie text-alerta hover:bg-alerta-fundo",
  // Sobre fundo de ação (barra de seleção).
  invertido: "text-acao-texto hover:bg-acao-hover",
};

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: VarianteBotao;
  /** "lg" ao lado de campo de formulário; padrão nas barras e linhas. */
  grande?: boolean;
  icone?: ReactNode;
  carregando?: boolean;
  /** Só ícone: exige rótulo para leitor de tela. */
  soIcone?: boolean;
};

export const Botao = forwardRef<HTMLButtonElement, Props>(function Botao(
  { variante = "secundario", grande, icone, carregando, soIcone, className, children, disabled, type, ...resto },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? "button"}
      disabled={disabled || carregando}
      aria-busy={carregando || undefined}
      className={cx(
        "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-controle px-3 text-corpo font-medium whitespace-nowrap",
        "transition-[background-color,color,transform] duration-150 ease-saida active:scale-[0.97]", // design-ok: aperto
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100",
        grande ? "h-controle-lg" : "h-controle",
        VARIANTE[variante],
        soIcone && "aspect-square px-0",
        className,
      )}
      {...resto}
    >
      {icone}
      {soIcone ? <span className="sr-only">{children}</span> : children}
    </button>
  );
});
